var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "add_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#add_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#009EE7",
  d: "M7.333 8.665H4a.645.645 0 0 1-.475-.191.645.645 0 0 1-.192-.475c0-.19.064-.348.192-.475A.645.645 0 0 1 4 7.332h3.333V3.999c0-.19.064-.348.192-.475A.645.645 0 0 1 8 3.332c.189 0 .347.064.475.192a.645.645 0 0 1 .191.475v3.333H12c.189 0 .347.064.475.192a.645.645 0 0 1 .191.475.645.645 0 0 1-.191.475.645.645 0 0 1-.475.191H8.666V12a.645.645 0 0 1-.191.475.645.645 0 0 1-.475.191.645.645 0 0 1-.475-.191.645.645 0 0 1-.192-.475V8.665Z"
}))));
export default SvgAdd;